import { Modal } from 'react-bootstrap';
import React, { Fragment } from 'react';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import { StyledLabel, Wrap } from '../../../assets/styledComponents/Global';
import CrossIcon from '../../../app/components/svgIcons/CrossIcon';
import { useTheme } from 'styled-components';
import SureDeleteIcon from '../../../app/components/svgIcons/SureDeleteIcon';

const DeleteDepartmentModal = ({
  show,
  onHide,
  onSubmit,
  type,
  itemName,
  deleteloading,
  deleteDepartment,
  size = 'lg',
  title = 'Are you sure about it?',
  descriptionLines,
  confirmLabel = 'Yes, Delete',
  cancelLabel = 'No, Cancel',
}) => {
  const theme = useTheme();
  const hasCustomCopy = Array.isArray(descriptionLines) && descriptionLines.length > 0;

  return (
    <Modal show={show} backdrop="static" centered onHide={onHide} size={size}>
      <Modal.Body className="d-flex flex-column bg-body rounded-3 align-items-center">
        <Wrap className="d-flex justify-content-end w-100">
          <CrossIcon className="ms-auto cursor-pointer" size={19} onClick={onHide} />
        </Wrap>
        <Fragment>
          <SureDeleteIcon />

          <StyledLabel weight={600} size="24px" className="mt-3 text-center">
            {title}
          </StyledLabel>
          {hasCustomCopy ? (
            descriptionLines.map((line) => (
              <StyledLabel
                key={line}
                weight={400}
                size="16px"
                color={theme?.textColor}
                className="text-center"
              >
                {line}
              </StyledLabel>
            ))
          ) : (
            <>
              <StyledLabel weight={400} size="16px" color={theme?.textColor} className="text-center">
                This action cannot be undone and will permanently {type ? 'remove' : ''}
              </StyledLabel>
              <StyledLabel weight={400} size="16px" color={theme?.textColor} className="text-center">
                {type && itemName
                  ? `the ${type} "${itemName}" from here.`
                  : type
                    ? `the selected ${type} from here.`
                    : 'remove the item from here.'}
              </StyledLabel>
            </>
          )}

          <div className="d-flex justify-content-end my-3">
            <div className="d-flex gap-3">
              <StyledButton
                onClick={() => onSubmit(deleteDepartment)}
                disabled={deleteloading}
                loading={deleteloading}
                className="fw-bold"
                type="button"
                variant="white"
              >
                {confirmLabel}
              </StyledButton>
              <StyledButton
                variant="primary"
                className="fw-bold"
                onClick={onHide}
                disabled={deleteloading}
              >
                {cancelLabel}
              </StyledButton>
            </div>
          </div>
        </Fragment>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteDepartmentModal;
